<script setup>
defineProps({
  title: { type: String, required: true },
  links: { type: Array, default: () => [] }
});
</script>

<template>
  <div class="vsb-footer__column">
    <h3 class="vsb-footer__heading">{{ title }}</h3>
    <ul class="vsb-footer__links">
      <li v-for="(link, index) in links" :key="`${link.href}-${index}`">
        <a :href="link.href">{{ link.label }}</a>
      </li>
    </ul>
  </div>
</template>
